import React from "react";

import {
  IconRotate360Off,
  IconVideo,
  IconThumbnail,
} from "@at/design-system-icons";

import {
  GalleryGridFpaViewImages,
  ViewMoreButton,
} from "./view-more-images.styled";

export interface FpaGridViewMoreImagesProps {
  showSlide: () => void;
  className?: string;
  viewImage?: boolean;
  viewSpin?: boolean;
  viewVideo?: boolean;
}

export const FpaGridViewMoreImages = ({
  className,
  showSlide,
  viewSpin = false,
  viewVideo = false,
  viewImage = false,
}: FpaGridViewMoreImagesProps) => {
  const imagesOnly = viewImage && !viewSpin && !viewVideo;
  const multipleMediaTypes =
    (viewImage && (viewSpin || viewVideo)) ||
    (viewSpin && (viewImage || viewVideo)) ||
    (viewVideo && (viewImage || viewSpin));

  return (
    <GalleryGridFpaViewImages
      data-testid="gallery-view-more-button"
      forceDisplay={!viewImage && (viewSpin || viewVideo)}
      className={className}
      onClick={() => {
        showSlide();
      }}
    >
      {multipleMediaTypes || imagesOnly ? (
        <>
          <IconThumbnail title="Vehicle gallery" />
          <ViewMoreButton>View gallery</ViewMoreButton>
        </>
      ) : viewVideo ? (
        <>
          <IconVideo title="Vehicle video" />
          <ViewMoreButton>View video</ViewMoreButton>
        </>
      ) : viewSpin ? (
        <>
          <IconRotate360Off title="Vehicle 360" additionalClass="spin-icon" />
          <ViewMoreButton>View 360</ViewMoreButton>{" "}
        </>
      ) : null}
    </GalleryGridFpaViewImages>
  );
};
